import { openMyCarSlotChat } from '../../utils/openChat';
import { DEALERSHIP_PHONE_DISPLAY } from '../../constants/dealershipContact';
import DealershipPhoneLink from '../../components/ALLJsx/DealershipPhoneLink';
import { Link } from 'react-router-dom';
import { ChevronRight, Phone, MessagesSquare, MapPin } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';

export function FaqBreadcrumb({ items }) {
  return (
    <nav className="faq-crumb" aria-label="Breadcrumb">
      <ol className="faq-crumb-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="faq-crumb-item">
              {item.to && !isLast ? (
                <Link to={item.to}>{item.label}</Link>
              ) : (
                <span aria-current={isLast ? 'page' : undefined}>{item.label}</span>
              )}
              {!isLast && <ChevronRight size={14} strokeWidth={2.5} aria-hidden />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export function FaqExpertSection() {
  const { t } = useLocale();

  return (
    <section className="faq-contact" aria-labelledby="faq-contact-title">
      <div className="faq-shell">
        <h2 id="faq-contact-title" className="faq-contact-title">
          {t('faqSupport.expertTitle')}
        </h2>

        <div className="faq-contact-duo">
          <div className="faq-contact-panel faq-contact-panel--chat">
            <MessagesSquare className="faq-contact-panel-icon" size={40} strokeWidth={1.75} aria-hidden />
            <p className="faq-contact-panel-text">{t('faqSupport.contactChatBody')}</p>
            <button type="button" className="faq-contact-btn" onClick={openMyCarSlotChat}>
              <MessagesSquare size={18} strokeWidth={2.25} aria-hidden />
              {t('faqSupport.contactChatBtn')}
            </button>
          </div>

          <div className="faq-contact-panel faq-contact-panel--hq">
            <MapPin className="faq-contact-panel-icon" size={40} strokeWidth={1.75} aria-hidden />
            <h3 className="faq-contact-panel-heading">{t('faqSupport.contactHqTitle')}</h3>
            <p className="faq-contact-panel-text">{t('faqSupport.contactHqBody')}</p>
            <DealershipPhoneLink
              className="faq-contact-btn"
              aria-label={t('faqSupport.contactCallAria', { phone: DEALERSHIP_PHONE_DISPLAY })}
            >
              <Phone size={18} strokeWidth={2.25} aria-hidden />
              {t('faqSupport.contactCallBtn', { phone: DEALERSHIP_PHONE_DISPLAY })}
            </DealershipPhoneLink>
          </div>
        </div>
      </div>
    </section>
  );
}
